import { Injectable } from '@angular/core';
import { AngularFirestoreDocument, AngularFirestore } from '@angular/fire/firestore';
import { CustomLink} from '../models/CustomLink';
import { DataService } from './data.service';

import { ToastComponent } from '../shared/toast/toast.component';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CustomLinkService {

  customLinkDoc: AngularFirestoreDocument<CustomLink>;
  constructor(private firestore: AngularFirestore,public dataService: DataService,public toastComponent: ToastComponent) 
  {  this.toastComponent = toastComponent}
  
  customLink: CustomLink = {
    link: "",
    omschrijving:"",
  }
  getCustomLink(id:string): Observable<CustomLink>
  {
    return this.firestore.collection("CustomLink").doc<CustomLink>(id).get().pipe(take(1),
      map(queryResult => {
        if(queryResult.exists){
          const data = queryResult.data() as CustomLink;
          const id = queryResult.id;
          this.dataService.customLink = data;
          return {id, ...data};
        }
        else{
          return null;
        }
      }));
  }
  async addCustomLink()
  {
    let customLinkId = '';
    await this.firestore.collection("CustomLink").add(this.customLink).then(function(docRef){
      customLinkId = docRef.id
    })
    return customLinkId;
  }
   //Deze methode wordt alleen gebruikt wanneer de priveAdmin een nieuwe onderneming aanmaakt.
   updateNaToevoegen(id: string, ondernemingId:string, ondernemingNaam:string)
   {
    this.customLink.ondernemingId = ondernemingId;
    this.customLink.ondernemingNaam = ondernemingNaam;
     this.customLink.id = id;
     this.updateCustomLink(this.customLink);
   }
   
  async updateCustomLink(customLink: CustomLink) {
    try {
      this.customLinkDoc = this.firestore.doc(`CustomLink/${customLink.id}`);
      await this.customLinkDoc.update(customLink);
      this.dataService.customLink = customLink
      // this.toastComponent.showSuccess();
    } catch (err) {
      console.log(err);
    }
  }
  
  deleteCustomLink(id: string){
    this.customLinkDoc = this.firestore.doc(`CustomLink/${id}`);
    this.customLinkDoc.delete();
  }
}
